import React from 'react';
import SettingsContainer, { SettingsSettingType } from '../../../components/settings/SettingsContainer';
import { useAuthContext } from 'services/authentication/AuthenticationContext';

const JobAppSettings: React.FC = () => {
    const { packageFeatures } = useAuthContext();

    // Determine if the required fields checkboxes must be greyed out
    const requiredFieldsDisabled = !packageFeatures.includes('mobile_required_fields');

    const settings: SettingsSettingType[] = [
        {
            title: 'job.app_settings.create_jobs_via_app_title',
            scope: 'division',
            explanationText: 'job.app_settings.create_jobs_via_app_explanation',
            switchButton: {
                enabled: true,
                name: 'mobile_create_jobs',
            }
        },
        {
            title: 'job.app_settings.offline_customer_database_title',
            scope: 'division',
            subSetting: true,
            requiredFeature: 'mobile_offline_database',
            dependentOn: { fieldName: 'mobile_create_jobs', value: true },
            explanationText: 'job.app_settings.offline_customer_database_explanation',
            switchButton: {
                enabled: true,
                name: 'mobile_offline_customer_database',
            }
        },
        {
            title: 'job.app_settings.default_view_title',
            scope: 'division',
            explanationText: 'job.app_settings.default_view_explanation',
            fields: [
                {
                    type: 'tabs',
                    name: 'mobile_appointment_display_mode',
                    buttonSize: 'large',
                    options: [
                        { value: 'list', name: 'job.app_settings.list_per_day_option' },
                        { value: 'agenda', name: 'job.app_settings.agenda_option' }
                    ]
                }
            ]
        },
        {
            title: 'job.app_settings.appointment_visibility_title',
            scope: 'division',
            explanationText: 'job.app_settings.appointment_visibility_explanation',
            fields: [
                {
                    type: 'tabs',
                    name: 'mobile_appointment_visibility',
                    buttonSize: 'large',
                    options: [
                        { value: 'today', name: 'job.app_settings.today_only_option' },
                        { value: 'today_tomorrow', name: 'job.app_settings.today_and_tomorrow_option' },
                        { value: 'always', name: 'job.app_settings.always_show_option' }
                    ]
                }
            ]
        },
        {
            title: 'job.app_settings.sequential_jobs_title',
            scope: 'division',
            requiredFeature: 'sequential_jobs',
            explanationText: 'job.app_settings.sequential_jobs_explanation',
            switchButton: {
                enabled: true,
                name: 'mobile_sequential_jobs',
            }
        },
        {
            title: 'job.app_settings.round_off_hours_title',
            scope: 'division',
            explanationText: 'job.app_settings.round_off_hours_explanation',
            fields: [
                {
                    type: 'dropdown',
                    name: 'mobile_round_off_hours',
                    allowNoneOption: false,
                    showSearch: false,
                    hardcodedOptions: [
                        { value: 'none', name: 'job.app_settings.no_rounding_option' },
                        { value: '5min', name: 'job.app_settings.round_5_minutes_option' },
                        { value: '15min', name: 'job.app_settings.round_15_minutes_option' },
                        { value: '30min', name: 'job.app_settings.round_30_minutes_option' },
                        { value: 'hour', name: 'job.app_settings.round_hour_option' }
                    ]
                }
            ]
        },
        {
            title: 'job.app_settings.create_products_title',
            scope: 'division',
            explanationText: 'job.app_settings.create_products_explanation',
            switchButton: {
                enabled: true,
                name: 'mobile_create_products',
            }
        },
        {
            title: 'job.app_settings.show_prices_title',
            scope: 'division',
            explanationText: 'job.app_settings.show_prices_explanation',
            switchButton: {
                enabled: true,
                name: 'mobile_payments',
            }
        },
        {
            title: 'job.app_settings.required_fields_title',
            scope: 'division',
            requiredFeature: 'mobile_required_fields',
            explanationText: 'job.app_settings.required_fields_explanation',
            fields: [
                { type: 'checkbox', align: 'left', disabled: requiredFieldsDisabled, name: 'mobile_require_job_description', label: 'job.app_settings.require_job_description_label' },
                { type: 'checkbox', align: 'left', disabled: requiredFieldsDisabled, name: 'mobile_require_travel_time', label: 'job.app_settings.require_travel_time_label' },
                { type: 'checkbox', align: 'left', disabled: requiredFieldsDisabled, name: 'mobile_require_work_time', label: 'job.app_settings.require_work_time_label' },
                { type: 'checkbox', align: 'left', disabled: requiredFieldsDisabled, name: 'mobile_require_customer_signature', label: 'job.app_settings.require_customer_signature_label' },
                { type: 'checkbox', align: 'left', disabled: requiredFieldsDisabled, name: 'mobile_require_employee_signature', label: 'job.app_settings.require_employee_signature_label' },
            ]
        },
        // Temporarily hidden until the mobile job storage is released
        // {
        //     title: 'Toon mobiele werkvoorraad',
        //     scope: 'division',
        //     explanationText: 'Toon de werkvoorraad met nog in de plannen opdrachten in de app. Op deze manier kan de buitendienst zelf opdrachten oppakken als ze tijd over hebben.',
        //     switchButton: {
        //         enabled: true,
        //         name: 'mobile_show_job_storage',
        //     }
        // },
    ];

    return (
        <SettingsContainer settings={settings} />
    );
};

export default JobAppSettings;